import { render } from "./ShopBasketItem.vue?vue&type=template&id=5e2509ec&scoped=true"
import script from "./ShopBasketItem.vue?vue&type=script&lang=js"
export * from "./ShopBasketItem.vue?vue&type=script&lang=js"

import "./ShopBasketItem.vue?vue&type=style&index=0&id=5e2509ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2509ec"]])

export default __exports__